import { SxProps, Theme } from "@mui/material";
import colors from "../theme/Colours";

export const dialogPaperSx: SxProps<Theme> = (theme) => ({
  borderRadius: theme.spacing(1.5),
  padding: theme.spacing(3),
  textAlign: "center",
  overflow: "visible",
  maxWidth: "70% !important",
});

// Order Summary delete-dialog styling
export const orderSummaryDialogPaperSx: SxProps<Theme> = (theme) => ({
  ...dialogPaperSx(theme),
  width: "400px",
  maxWidth: "400px !important",
  minHeight: "180px",
});

export const imageContainerSx: SxProps<Theme> = (theme) => ({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  paddingTop: theme.spacing(2),
});

export const dialogContentBoxSx: SxProps<Theme> = (theme) => ({
  borderRadius: theme.spacing(1),
  padding: theme.spacing(2),
});

export const titleTypographySx: SxProps<Theme> = (theme) => ({
  fontSize: { xs: "26px", sm: "36px" },
  marginBottom: theme.spacing(1.5),
});

// Order Summary delete-dialog title styling
export const orderSummaryTitleTypographySx: SxProps<Theme> = (theme) => ({
  fontSize: "18px",
  marginBottom: theme.spacing(1.5),
  fontWeight: 500,
});

export const messageTypographySx: SxProps<Theme> = (theme) => ({
  "& #OrdId": {
    color: colors.black,
    padding: theme.spacing(0.25),
    fontWeight: 500,
  },
  color: colors.greyTypography,
  fontWeight: 400,
  fontFamily: "Roboto",
});

export const dialogActionsSx: SxProps<Theme> = (theme) => ({
  justifyContent: "center",
  gap: theme.spacing(2),
  margin: `${theme.spacing(2)} ${theme.spacing(6)}`,
});

// orange outlined button (for "No" button)
export const orangeOutlinedButtonSx: SxProps<Theme> = (theme) => ({
  borderColor: colors.primaryButtonOrange,
  color: colors.primaryButtonOrange,
  textTransform: "none",
  fontSize: { xs: "12px", sm: "16px" },
  borderRadius: theme.spacing(1),
  width: "60px",
  "&:hover": {
    backgroundColor: colors.primaryButtonOrangeDisabled,
  },
});

// Orange contained button (for "Yes" button)
export const orangeContainedButtonSx: SxProps<Theme> = (theme) => ({
  backgroundColor: colors.primaryButtonOrange,
  color: "#fff",
  textTransform: "none",
  fontSize: { xs: "12px", sm: "16px" },
  borderRadius: theme.spacing(1),
  width: "60px",
  "&:hover": {
    backgroundColor: colors.primaryButtonOrangeHover,
  },
});

export const outlinedButtonSx: SxProps<Theme> = (theme) => ({
  borderColor: colors.primaryButtonOrange,
  color: colors.primaryButtonOrange,
  textTransform: "none",
  fontSize: { xs: "12px", sm: " 16px" },
  borderRadius: theme.spacing(1),
});

export const containedButtonSx: SxProps<Theme> = (theme) => ({
  backgroundColor: colors.primaryButtonOrange,
  borderRadius: theme.spacing(1),
  textTransform: "none",
  "&:hover": {
    backgroundColor: colors.primaryButtonOrangeHover,
  },
});
export const containedOkButtonSx: SxProps<Theme> = (theme) => ({
  ...containedButtonSx(theme),
  width: "20%",
  backgroundColor: colors.primaryButtonOrange,
});
export const containedPrimaryButtonSx: SxProps<Theme> = (theme) => ({
  ...containedButtonSx(theme),
  backgroundColor: colors.primaryButtonOrange,
});

export const iconStyle: SxProps<Theme> = (theme) => ({
  paddingRight: theme.spacing(1.0625), // ~8.5px
});

export const truckIconStyle: SxProps<Theme> = (theme) => ({
  paddingRight: theme.spacing(1.3125), // ~10.5px
});
